module.exports = __webpack_public_path__ + "img/stream_hotel_tiny.07d73da7.png";